import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Captura `beforeinstallprompt` o quanto antes — o evento dispara uma única
// vez por load e geralmente ANTES dos componentes React montarem. Guarda em
// window.__deferredInstallPrompt pra InstallPWAButton ler quando renderizar.
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__deferredInstallPrompt = e;
  });
  window.addEventListener('appinstalled', () => {
    window.__deferredInstallPrompt = null;
  });

  // Auto-recovery quando o PWA tenta carregar um chunk antigo que não existe
  // mais (acontece quando deploy roda enquanto o usuário está com o app aberto
  // ou o SW segurou index.html antigo apontando pra chunks renomeados).
  // Detecta erro de import dinâmico e força reload UMA vez — flag em
  // sessionStorage evita loop se o problema for outro.
  const CHUNK_RELOAD_KEY = '__chunkErrorReload';
  function isChunkLoadError(msg) {
    if (!msg) return false;
    const m = String(msg).toLowerCase();
    return m.includes('importing a module script failed')
        || m.includes('failed to fetch dynamically imported module')
        || m.includes('module script failed to load')
        || m.includes("loading chunk")
        || m.includes('loading css chunk');
  }
  // true quando tryRecover vai de fato recarregar (erro de chunk e ainda não tentou)
  function willRecover(msg) {
    return isChunkLoadError(msg) && !sessionStorage.getItem(CHUNK_RELOAD_KEY);
  }
  function tryRecover(msg) {
    if (!willRecover(msg)) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    // Recuperação AGRESSIVA: só limpar o cache não basta — o service worker
    // antigo continua ativo e re-serve os mesmos chunks renomeados, deixando o
    // app preso na tela branca. Desregistra TODOS os SWs + limpa caches +
    // reload, garantindo que a próxima carga venha 100% da rede (build nova).
    const jobs = [];
    if ('serviceWorker' in navigator) {
      jobs.push(
        navigator.serviceWorker.getRegistrations()
          .then(regs => Promise.all(regs.map(r => r.unregister())))
          .catch(() => {})
      );
    }
    if ('caches' in window) {
      jobs.push(caches.keys().then(keys => Promise.all(keys.map(k => caches.delete(k)))).catch(() => {}));
    }
    Promise.all(jobs).finally(() => window.location.reload(true));
  }
  window.addEventListener('error', (e) => tryRecover(e?.message));
  window.addEventListener('unhandledrejection', (e) => tryRecover(e?.reason?.message || e?.reason));
  // Evento oficial do Vite quando o preload de um chunk dinâmico falha. Também
  // dispara quando o PRÓPRIO módulo quebra ao avaliar (ex.: ReferenceError).
  // preventDefault() faz o Vite engolir o erro e o import() resolver undefined:
  // o React.lazy então quebra com "e._result.default" e o erro real some. Por
  // isso só cancela quando o reload de recuperação vai acontecer; nos outros
  // casos o erro segue até o ErrorBoundary, que mostra a mensagem verdadeira.
  window.addEventListener('vite:preloadError', (e) => {
    const msg = e?.payload?.message || 'failed to fetch dynamically imported module';
    // CSS do chunk não carregou: cancelar aqui só faz o Vite seguir e carregar
    // o JS (se o JS também falhar, o erro volta por este mesmo evento).
    if (/unable to preload css/i.test(msg)) {
      e.preventDefault?.();
      return;
    }
    if (willRecover(msg)) {
      e.preventDefault?.();
      tryRecover(msg);
    }
  });
  // Limpa flag depois de 30s — assume que carregou bem
  setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY), 30000);
}

ReactDOM.createRoot(document.getElementById('root')).render(<React.StrictMode><App /></React.StrictMode>)
